import axios from "axios";
import { API } from "../../backend";
import multipart from "../user/mutlipart";

const addSupport = (
    description,
    message,
    supporttype,
    attachment
) => {
  return axios.post(
    API + "helper/create-supportticket/",
    {
        description,
        message,
        supporttype,
        attachment
    },
    { headers: multipart(), }
  );
};
const AddSupportService = {
    addSupport,

};
export default AddSupportService;
